$(document).ready(function() {
 if ($('body').hasClass('template-index')) {
    var $header = $('.header-wrapper');
    var $slideshow = $('.slideshow');
    var slideshowHeight = $slideshow.outerHeight();
    var desktopMinWidth = 1024; 
    function checkScroll() {
        // if ($(window).width() >= desktopMinWidth) {
            if ($(window).scrollTop() > slideshowHeight) {
                  $header.addClass('scrolled');
            } else {
                $header.removeClass('scrolled');
            }
        // } else {
        //     $header.removeClass('scrolled'); 
        // }
    }

    checkScroll();
    $(window).on('scroll', function() {
        checkScroll();
    });
    $(window).on('resize', function() {
        checkScroll();
    });
      }





 if ($('body').hasClass('template-product')) {
    var $header = $('.header-wrapper');
    var $slideshow = $('.product__media-wrapper');
    var slideshowHeight = $slideshow.outerHeight();
    var desktopMinWidth = 1024; 
    function checkScroll() {
        // if ($(window).width() >= desktopMinWidth) {
            if ($(window).scrollTop() > slideshowHeight) {
                  $header.addClass('sticky-scrolled');
            } else {
                $header.removeClass('sticky-scrolled');
            }
        // } else {
        //     $header.removeClass('scrolled'); 
        // }
    }

    checkScroll();
    $(window).on('scroll', function() {
        checkScroll();
    });
    $(window).on('resize', function() {
        checkScroll();
    });
      }  
 
$(".insta_feedSec .jdgm-rev-widg__title").text("Review");
   setTimeout( function(){ 
       $(".insta_feedSec .jdgm-rev-widg__title").text("Review");
  }  , 1000 );
   setTimeout( function(){ 
       $(".insta_feedSec .jdgm-rev-widg__title").text("Review");
  }  , 2000 );

            // $('.product__info-container .product__accordion').hover(
            //     function() {
            //         $('details').not($(this).find('details')).removeAttr('open');
            //         $(this).find('details').attr('open', 'open');
            //     },
            //     function() {
            //         $(this).find('details').removeAttr('open');
            //     }
            // );
});

// const menu = document.querySelector(".kora-select-menu");
// const [selectBtn, sBtnText] = [menu.querySelector(".kora-select-btn"), menu.querySelector(".sBtn-text")];

// selectBtn.onclick = () => menu.classList.toggle("active");

// menu.querySelectorAll(".kora-option").forEach(option => {
//   option.onclick = () => {
//     sBtnText.innerText = option.querySelector(".kora-option-text").innerText;
//     menu.classList.remove("active");
//   };
// });



$(document).ready(function() {
    const menu = $(".kora-select-menu");
    const selectBtn = menu.find(".kora-select-btn");
    const sBtnText = menu.find(".sBtn-text");

    selectBtn.on("click", function() {
        menu.toggleClass("active");
    });

    menu.find(".kora-option").each(function() {
        $(this).on("click", function() {
            const selectedText = $(this).find(".kora-option-text").text().trim();
            sBtnText.text(selectedText);
            menu.removeClass("active");

            // Auto-click the corresponding radio button
            $(`.size-radio[value="${selectedText}"]`).click();
           $(`input[name="Size"][value="${selectedText}"]`).click();
          
        });
    });

    var $sections = $('.animate__section .collection');

    function checkIfSectionVisible($section) {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var sectionTop = $section.offset().top;
        var sectionHeight = $section.height();

        if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
            $section.find('.animate-strip').addClass('slideInDown');
        } else {
            $section.find('.animate-strip').removeClass('slideInDown');
        }
    }

    function checkAllSectionsVisible() {
        $sections.each(function() {
            checkIfSectionVisible($(this));
        });
    }

    checkAllSectionsVisible();

    $(window).on('scroll', function() {
        checkAllSectionsVisible();
    });

    $(window).on('resize', function() {
        checkAllSectionsVisible();
    });


 
// $('.mega-menu').each(function() {
//   $(this).hover(
//     function(){
//       var $listItems = $(this).find('.mega-menu__list li');
//       $listItems.removeClass('slideInDown'); // Reset animation
//       setTimeout(function() {
//         $listItems.addClass('slideInDown'); // Add animation
//       }, 10); // Delay to allow resetting the animation
//     },
//     function(){
//       $(this).find('.mega-menu__list li').removeClass('slideInDown');
//     }
//   );
// });


  
});


 $(document).ready(function(){
            $('.innerkora01.custom-second-last').on('click', function() {
                $('.menumobiletrigger').click();
            });
           $('.innerkora02.custom-second-last').on('click', function() {
                $('.menumobiletrigger').click();
            });
        });



$(document).ready(function() {
    $('.click-on-img').click(function() {
         var link = $(this).find('.btn-white').attr('href');
         window.location.href = link;
    });
    $(".mobile-btn-action").on("click", function () {
        $(".giftnote-cart-wrapper").removeClass("mobile-hide");
    });
    $(".ok-btn, .cancel-btn").on("click", function () {
        $(".giftnote-cart-wrapper").addClass("mobile-hide");
    });
   $(document).on("click", function (event) {
        if (!$(event.target).closest(".giftnote-cart-outer, .mobile-btn-action").length) {
            $(".giftnote-cart-wrapper").addClass("mobile-hide");
        }
    });
});
 

// $(document).ready(function() {
//     // Define the breakpoint for mobile view
//     var mobileViewBreakpoint = 768;

//     // Function to move the element
//     function moveCurrencyChanger() {
//         if ($(window).width() <= mobileViewBreakpoint) {
//             var currencyChanger = $('.currency_changer').detach();
//             if (currencyChanger.length) {
//                 var newLi = $('<li class="innerkora01"></li>');
//                 newLi.append(currencyChanger);
//                 $('.menu-drawer__menu.has-submenu.list-menu').append(newLi);
//             }



          
//         }
//     }

//     // Initial check
//     moveCurrencyChanger();

//     // Check on window resize
//     $(window).resize(function() {
//         moveCurrencyChanger();
//     });
// });